const ADMIN_ONLY_META = {
  requireAdmin: true
};
const SYNC_MANAGE_ROUTE_META = {
  requireAdmin: true,
  requireVisibleAppCode: "USER_SYNC_MANAGEMENT"
};
export default [{
  path: "/MGT",
  name: "MGT",
  component: () => import("@/views/MGT/MGT/index.vue")
}, {
  path: "/MGT/member",
  name: "member",
  component: () => import("@/views/MGT/member/member.vue")
}, {
  path: "/MGT/position",
  name: "position",
  meta: {
    ...ADMIN_ONLY_META
  },
  component: () => import("@/views/MGT/position/position.vue")
}, {
  path: "/MGT/invite",
  name: "invite",
  meta: {
    ...ADMIN_ONLY_META
  },
  component: () => import("@/views/Invite/invite-setting.vue")
}, {
  path: "/MGT/unit",
  name: "unit",
  meta: {
    ...ADMIN_ONLY_META
  },
  component: () => import("@/views/Unit/unit.vue")
},
// {
//   path: "/MGT/unit",
//   component: () => import("@/views/MGT/ContactTag/Tag.vue"),
// },

{
  path: "/MGT/appManage",
  meta: {
    ...ADMIN_ONLY_META
  },
  component: () => import("@/views/MGT/AppManage.vue")
}, {
  path: "/MGT/interconnection",
  component: () => import("@/views/MGT/Corpcircle/Interconnection.vue")
}, {
  path: "/MGT/communicationUser",
  name: "MGT/communicationUser",
  component: () => import("@/views/MGT/CommunicationUser.vue")
}, {
  path: "/MGT/Structure/Detail",
  meta: {
    ...ADMIN_ONLY_META
  },
  component: () => import("@/views/MGT/ContactTag/OrgDetail.vue")
}, {
  path: "/MGT/GmRole",
  meta: {
    ...ADMIN_ONLY_META
  },
  component: () => import("@/views/MGT/ContactRmRole/GmRole.vue")
}, {
  path: "/MGT/Services",
  meta: {
    ...ADMIN_ONLY_META
  },
  component: () => import("@/views/MGT/Services.vue")
}, {
  path: "/MGT/myEnterprise",
  component: () => import("@/views/MGT/MyEnterprise/Enterprise.vue")
}, {
  path: "/MGT/AppUse",
  component: () => import("@/views/MGT/AppUse.vue")
}, {
  path: "/MGT/Version",
  component: () => import("@/views/MGT/Version/Version.vue")
}, {
  path: "/MGT/WhiteBlackList",
  meta: {
    ...ADMIN_ONLY_META
  },
  component: () => import("@/views/MGT/WhiteBlackList/WhiteBlackList.vue")
}, {
  path: "/MGT/SecuritySetting",
  meta: {
    ...ADMIN_ONLY_META
  },
  component: () => import("@/views/MGT/SecuritySetting/SecuritySetting.vue")
}, {
  path: "/MGT/promotions",
  component: () => import("@/views/MGT/Promotions/PromotionList.vue")
}, {
  path: "/MGT/reflection",
  name: "reflection",
  meta: {
    ...ADMIN_ONLY_META
  },
  component: () => import("@/views/MGT/SysManager/UnitReflection.vue")
}, {
  path: "/MGT/idManager",
  name: "idManager",
  meta: {
    ...ADMIN_ONLY_META
  },
  component: () => import("@/views/MGT/SysManager/IdentityManager.vue")
}, {
  path: "/MGT/authManager",
  name: "authManager",
  meta: {
    ...ADMIN_ONLY_META
  },
  component: () => import("@/views/MGT/SysManager/AuthManager.vue")
}, {
  path: "/MGT/syncManage",
  name: "syncManage",
  meta: {
    ...SYNC_MANAGE_ROUTE_META
  },
  component: () => import("@/views/MGT/SyncManage/SyncManage.vue")
}, {
  path: "/MGT/audit",
  name: "auditManage",
  meta: {
    ...ADMIN_ONLY_META
  },
  component: () => import("@/views/MGT/SysManager/AuditManager.vue")
}, {
  path: "/MGT/app-mamage",
  name: "app-mamage",
  meta: {
    ...ADMIN_ONLY_META
  },
  component: () => import("@/views/MGT/MGT/page/app-manage.vue")
}, {
  path: "/MGT/app-detail",
  name: "app-detail",
  meta: {
    ...ADMIN_ONLY_META
  },
  component: () => import("@/views/MGT/MGT/page/app-detail.vue")
}];